// Genre filter for kids profile (TMDB genre ids)
// Hide: Horror(27), Crime(80), Thriller(53), War(10752), Western(37)
const BLOCKED_GENRES = new Set([27, 80, 53, 10752, 37]);
// Adult content flag is also filtered out via TMDB include_adult=false everywhere

export const filterForKids = (items, isKids) => {
  if (!isKids || !Array.isArray(items)) return items || [];
  return items.filter((it) => {
    if (it.adult) return false;
    const ids = it.genre_ids || [];
    if (ids.some((id) => BLOCKED_GENRES.has(id))) return false;
    // also rely on vote average threshold for safer kid content
    return true;
  });
};
